import { styled } from "theme/default/styled";
import { setFlexDFJCSA } from "theme/setter/setFlexValues/setFlexDFJCSA";

export const SRolesSelectFormContentButtons = styled.div`
  margin-top: 24px;

  ${setFlexDFJCSA};
`;
